import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-6 w-[calc(100%+32px)] pb-6"
}
const _hoisted_2 = { class: "mx-6 mt-8 border rounded-lg border-neutral-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Filter", -1)
const _hoisted_6 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Sort", -1)
const _hoisted_8 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_9 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_11 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_12 = { class: "p-1 space-y-5" }
const _hoisted_13 = { class: "p-1 space-y-5" }
const _hoisted_14 = { class: "p-1 space-y-5" }
const _hoisted_15 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_19 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_20 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_21 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_22 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_23 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "w-full px-6 border-t py-7" }
const _hoisted_27 = { class: "w-full px-6 border-t py-7" }

import { ref, onMounted, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import DataTable from '@/components/partials/DataTable.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import ExportButton from '@/components/buttons/ExportButton.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { FunnelIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/outline";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import ReportService from '@/classes/Reports/ReportService';

import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";
import debounce from "lodash/debounce";

import DateFormatter from "@/helpers/DateFormatter";
import { SelectInterface } from '@/interfaces/pages/BasePageInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportInterventionRecord',
  setup(__props) {

const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const items = ref<any>([]);
const interventionType = ref<SelectInterface>([]);

const sortOptions = [
    { id: '1', label: 'Create At', value: 'created_at'},
]

const orderOptions = [
    { id: 'asc', label: 'Ascending', value: 'asc'},
    { id: 'desc', label: 'Descending', value: 'desc'},
]

const headers: { text: string }[] = [
    { text: 'Intervention ID' },
    { text: 'Case No.' },
    { text: 'Patient' },
    { text: 'Intervention Type' },
    { text: 'Type' },
    { text: 'Sub-Type' },
    { text: 'Schedule Date' },
    { text: 'Done On' },
    { text: 'Done By' },
    { text: 'Remarks' },
];

const filters = ref({
    rows: 10,
    column: 'created_at',
    query: null,
    order: 'asc',
    created_at: null,
    intervention_type: null, 
    done_on: null, 
    office_id: null,
    scheduled_date: null,
});

const paginate = ( page:number, rows:number )=>{
    ReportService.paginate(page, rows,filters.value, getData)
}

const applyFilters = () => {
    showFilter.value = false;
    paginate( 1, filters.value.rows);
};


const applyReset = () => {
    showFilter.value = false;
    filters.value.created_at = null;
    filters.value.intervention_type = null;
    filters.value.done_on = null;
    filters.value.scheduled_date = null;
    paginate( 1, filters.value.rows);
};

const getData =  (): void =>{
    loading.value = true; 
    
    ReportService.index('intervention-record', omitBy(filters.value, isNil))
        .then(({data})=>{ 
            items.value = data.items;
            interventionType.value = data.interventionTypes;
        })
        .catch((error: any)=>{
            console.log(error)
        })
        .finally(() => loading.value = false)
} 

const exporting = (): void => {
    loading.value = true;
    ReportService
        .export('intervention-record', omitBy(filters.value, isNil))
        .then(({data})=>{
            ReportService.downloadExport("intervention-record-export.csv",data);  
        })
        .finally(() => loading.value = false)
}

/**
 * WATCHERS
 */
watch(
    () => filters.value.query,
    debounce(() => {
        paginate( 1, filters.value.rows);
        applyReset();
    }, 500)
);

onMounted(()=> {
    getData();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Intervention report by patient",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      _createVNode(ExportButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exporting()))
      })
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DataTable, {
                  hasSearch: true,
                  searchPlaceholder: "Search Name of Personnel, Patient",
                  headers: headers,
                  "no-action": true,
                  count: items.value?.total,
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  search: filters.value.query,
                  "onUpdate:searchText": _cache[14] || (_cache[14] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showFilter.value = true))
                      }, [
                        _createVNode(_unref(FunnelIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                        _hoisted_5
                      ]),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(ArrowsUpDownIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_7
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(RadioGroup, {
                                        options: sortOptions,
                                        name: "sortOptions",
                                        modelValue: filters.value.column,
                                        "onUpdate:modelValue": [
                                          _cache[2] || (_cache[2] = ($event: any) => ((filters.value.column) = $event)),
                                          _cache[3] || (_cache[3] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(RadioGroup, {
                                        options: orderOptions,
                                        name: "orderOptions",
                                        modelValue: filters.value.order,
                                        "onUpdate:modelValue": [
                                          _cache[4] || (_cache[4] = ($event: any) => ((filters.value.order) = $event)),
                                          _cache[5] || (_cache[5] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[11] || (_cache[11] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[12] || (_cache[12] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[13] || (_cache[13] = ($event: any) => (applyFilters())),
                        customClass: "!overflow-visible overflow-x-visible"
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(DatePicker, {
                              id: "scheduled_date",
                              name: "scheduled_date",
                              label: "Scheduled Date",
                              modelValue: filters.value.scheduled_date,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.scheduled_date) = $event)),
                              onCleared: _cache[7] || (_cache[7] = ($event: any) => (filters.value.scheduled_date = null)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(DatePicker, {
                              id: "done_on",
                              name: "done_on",
                              label: "Done On",
                              modelValue: filters.value.done_on,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.done_on) = $event)),
                              onCleared: _cache[9] || (_cache[9] = ($event: any) => (filters.value.done_on = null)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(MultiSelect, {
                              options: interventionType.value,
                              label: "Intervention type",
                              id: "type_filter",
                              name: "type_filter",
                              placeholder: "Select..",
                              modelValue: filters.value.intervention_type,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.value.intervention_type) = $event)),
                              searchable: ""
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.id), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.case_no), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(item.patient), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(item.intervention), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(item.type), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(item.subtype), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(DateFormatter).customDateFormat(item.schedule_date, "MMM dd, yyy - hh:mm a")), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(item.done_on ? _unref(DateFormatter).customDateFormat(item.done_on, "MMM dd, yyy - hh:mm a") : "-"), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(item.done_by), 1),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("p", {
                            innerHTML: item.remarks
                          }, null, 8, _hoisted_25)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count", "search"]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(SimplePagination, {
                      numRows: filters.value?.rows ?? 10,
                      currentPage: items.value?.current_page,
                      "last-page": items.value?.last_page,
                      onUpdate: _cache[15] || (_cache[15] = (value) => paginate(value.page, value.rows))
                    }, null, 8, ["numRows", "currentPage", "last-page"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoadingModal, {
        show: loading.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})